var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-bread-crumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadCrumbList),function(breadCrumbData,index){return _c('el-breadcrumb-item',{key:index},[_c('router-link',{attrs:{"to":breadCrumbData.path}},[_vm._v(_vm._s(breadCrumbData.name))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }